var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mortgage-list"},_vm._l((_vm.programs),function(item){return _c('MortgageCardComponent',{key:item.id,attrs:{"content":item,"flatPrice":_vm.flatPrice},on:{"popupShow":_vm.popupHandler}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }